import { SetupAuth } from "../../client";

export type GetAllTabsRow = {
  id: string;
  name: string;
  skill_id?: string;
  skill_name?: string;
};

export async function fetchAllTabs(
  ambient: string,
  authorization: string,
  isForce: boolean
): Promise<GetAllTabsRow[] | undefined> {
  try {
    const api = SetupAuth(authorization);
    const { data } = await api.get<GetAllTabsRow[]>(
      `/get-all-tabs?ambient=${encodeURIComponent(ambient)}&isForce=${isForce ? "true" : "false"}`
    );
    return Array.isArray(data) ? data : undefined;
  } catch {
    return undefined;
  }
}
